/**
 * External dependencies.
 */
import { Trans } from "@lingui/macro";
import React, { useState } from "react";
import classNames from "classnames";
import { useRouter } from "next/router";

/**
 * Internal dependencies.
 */
import Link from "components/link/link";
import Useful from "components/useful/useful";
import Markdown from "components/markdown/markdown";
import { getSlug } from "utils";

interface SideContentProp {
  data: any;
  title: string;
  current: any;
  global: any;
  app?: boolean;
}

const SideContent: React.FC<SideContentProp> = ({
  data,
  title,
  current,
  global,
  app,
}) => {
  const key = app ? 'app' : 'theme';
  const router = useRouter();
  const [active, setActive] = useState(false);
  const handleActive = () => setActive(true);
  
  return (
    <div className="side-content">
      <div className="container container--small">
        <h4 className="side-content__title">{title}</h4>
        <div className="side-content__flex">
          <div className="sidebar">
            <div className="sidebar__mobile">
              <button type="button" onClick={handleActive}>
                {current ? current.attributes.Title : data[0].attributes.Title} <span></span>
              </button>
            </div>
            {data.map((item: any) => (
              <div
                className={classNames("button-holder", { active: active })}
                key={item.id}
              >
                <Link
                  href={`/help-center/faqs/${app ? 'app' : 'theme'}/${router.query.theme}/${getSlug(item.attributes)}`}
                  className={classNames("button", {
                    "is-active":
                      item.attributes.slug === current.attributes.slug,
                  })}
                >
                  {item.attributes.Title}
                </Link>
              </div>
            ))}
            <Link
              href={global.attributes.ContactLink}
              className="btn btn--grey"
            >
              <Trans>Contact Us</Trans>
            </Link>
          </div>
          <div className="content">
            <div className="content_item">
              <h5>{current.attributes.Title}</h5>
              <Markdown content={current.attributes.Content} />
              <Link
                href={global.attributes.ContactLink}
                className="btn btn--grey mobile-only"
              >
                <Trans>Contact Us</Trans>
              </Link>
            </div>
            <Useful path={`/faqs/${current.id}`} global={global} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideContent;
